import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("common");

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-xl font-semibold text-background-50 mb-4">
              华丽的外出
            </h3>
            <p className="text-sm text-background-300 leading-relaxed max-w-xs">
              从穿搭到妆容，从配饰到仪态，全方位打造令人过目难忘的出行风格。让每一次外出都散发华丽气场。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                首页
              </Link>
              <Link to="/category/chuanda-gonglue" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                穿搭攻略
              </Link>
              <Link to="/category/peishi-dapei" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                配饰搭配
              </Link>
              <Link to="/category/zhuangrong-jiaocheng" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                妆容教程
              </Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-background-50 mb-4">
              关注我们
            </h4>
            <div className="flex flex-col gap-3 text-sm text-background-300">
              <span>微信公众号：华丽的外出</span>
              <span>小红书：华丽的外出</span>
              <span>contact@hualidewaichu.com</span>
            </div>
            <div className="flex gap-4 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-background-700 hover:text-background-100 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-background-700 hover:text-background-100 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-background-700 hover:text-background-100 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-reddit-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 华丽的外出. All Rights Reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}